// extracted by mini-css-extract-plugin
export default {"textThCell":"textThCell_textThCell__ykGyy"};